{
  "name": "dragonfly",
  "version": "6.5.0+V30",
  "author": "galaveras@inteliqua.com",
  "homepage": "https://eliquacx.com/",
  "scripts": {
    "start": "ng serve --port 9000",
    "build:dev": "ng build --configuration development",
    "build:prod": "ng build --configuration production",
    "test": "ng test",
    "lint": "ng lint",
    "format": "prettier --config .prettierrc.json --write .",
    "format:check": "prettier --config .prettierrc.json --check .",
    "prepare": "husky",
    "sonar": "sonar-scanner-npm",
    "sonar:branch": "node scripts/run-sonar.js",
    "localdev:lin": "node scripts/localDevelopmentLin.js",
    "localdev:win": "node scripts/localDevelopmentWin.js"
  },
  "engines": {
    "node": ">=22.12.0",
    "npm": ">=10.0.0"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.34",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "20.3.34",
    "@angular/compiler": "20.3.34",
    "@angular/core": "20.3.34",
    "@angular/forms": "20.3.34",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "20.3.34",
    "@angular/platform-browser-dynamic": "20.3.34",
    "@angular/router": "20.3.34",
    "@bluehalo/ngx-leaflet": "^20.0.0",
    "@danielmoncada/angular-datetime-picker": "^20.0.0",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-svg-core": "^6.7.1",
    "@fortawesome/free-solid-svg-icons": "^6.7.1",
    "@ngrx/effects": "^20.1.0",
    "@ngrx/entity": "^20.1.0",
    "@ngrx/store": "^20.1.0",
    "@ngrx/store-devtools": "^20.1.0",
    "@swimlane/ngx-charts": "^23.0.0",
    "@types/uuid": "^10.0.0",
    "date-fns": "^2.29.3",
    "file-saver": "^2.0.5",
    "jsoneditor": "^10.2.0",
    "leaflet": "^1.9.4",
    "marked": "^16.4.0",
    "ngx-markdown": "^20.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1",
    "uuid": "^14.0.3",
    "zone.js": "^0.15.1"
  },
  "overrides": {
    "@angular/animations": "20.3.34",
    "@angular/common": "20.3.34",
    "@angular/compiler": "20.3.34",
    "@angular/compiler-cli": "20.3.34",
    "@angular/core": "20.3.34",
    "@angular/forms": "20.3.34",
    "@angular/localize": "20.3.34",
    "@angular/platform-browser": "20.3.34",
    "@angular/platform-browser-dynamic": "20.3.34",
    "@angular/router": "20.3.34",
    "axios": "^1.20.0",
    "brace-expansion": "^1.1.21",
    "braces": "^3.0.3",
    "browserslist": "^4.28.7",
    "compression": "^1.8.2",
    "dompurify": "^3.4.16",
    "engine.io": "^6.6.10",
    "esbuild": "^0.28.1",
    "fast-glob": "^3.3.2",
    "fast-uri": "^3.1.7",
    "katex": "^0.16.21",
    "http-cache-semantics": "^4.2.1",
    "http-proxy-middleware": "^2.0.9",
    "ip-address": "^10.7.1",
    "js-yaml": "^4.3.2",
    "micromatch": "^4.0.8",
    "nanoid": "^3.3.18",
    "node-forge": "^1.3.1",
    "piscina": "^5.1.0",
    "postcss": "^8.5.23",
    "postcss-selector-parser": "^7.1.6",
    "qs": "^6.15.4",
    "shell-quote": "^1.8.5",
    "socket.io-parser": "^4.2.7",
    "source-map-js": "^1.2.2",
    "tar": "^7.5.21",
    "undici": "^6.28.1",
    "webpack-dev-middleware": "^7.4.5"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.33",
    "@angular-eslint/builder": "^20.0.0",
    "@angular-eslint/eslint-plugin": "^20.0.0",
    "@angular-eslint/eslint-plugin-template": "^20.0.0",
    "@angular-eslint/schematics": "^20.0.0",
    "@angular-eslint/template-parser": "^20.0.0",
    "@angular/cli": "~20.3.33",
    "@angular/compiler-cli": "20.3.34",
    "@angular/localize": "20.3.34",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "^4.6.4",
    "@types/jsoneditor": "^9.9.5",
    "@types/leaflet": "^1.9.21",
    "@typescript-eslint/eslint-plugin": "^8.70.0",
    "@typescript-eslint/parser": "^8.70.0",
    "eslint": "^8.57.1",
    "husky": "^9.1.7",
    "jasmine-core": "~4.5.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "lint-staged": "^16.4.0",
    "prettier": "3.9.4",
    "prettier-plugin-organize-imports": "^4.3.0",
    "sonarqube-scanner": "^5.0.2",
    "typescript": "~5.8.3"
  }
}